import { TitleCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ViewEncapsulation,
} from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { IconComponent } from '@sc/ui-components';
import { dayjs } from '@sc/utils';
import { Dayjs } from 'dayjs';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'sc-mobile-planning-calendar-header',
  styleUrls: ['./mobile-planning-calendar-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TitleCasePipe],
  template: `
    <div class="mobile-calendar-custom-header">
      <button mat-icon-button (click)="arrowClicked(false)">
        <sc-icon class="arrow left" name="arrow_left" tabindex="0"></sc-icon>
      </button>
      <span class="mobile-calendar-custom-label">{{
        periodLabel | titlecase
      }}</span>
      <button mat-icon-button (click)="arrowClicked(true)">
        <sc-icon class="arrow left" name="arrow_right" tabindex="0"></sc-icon>
      </button>
    </div>
  `,
})
export class MobilePlanningCalendarHeaderComponent implements OnDestroy {
  private readonly _destroyed = new Subject<void>();
  periodLabel;
  constructor(
    private readonly _calendar: MatCalendar<Dayjs>,
    private readonly _dateAdapter: DateAdapter<Dayjs>,
    cdr: ChangeDetectorRef
  ) {
    this.setPeriodLabel();
    _calendar.stateChanges.pipe(takeUntil(this._destroyed)).subscribe(() => {
      cdr.markForCheck();
      this.setPeriodLabel();
    });
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  setPeriodLabel() {
    this.periodLabel = dayjs(this._calendar.activeDate)
      .format('MMMM YYYY')
      ?.toString()
      ?.toLowerCase();
  }

  arrowClicked(isNext: boolean) {
    const newDate = this._dateAdapter.addCalendarMonths(
      this._calendar.activeDate,
      isNext ? 1 : -1
    );
    this._calendar.activeDate = newDate;
    this._calendar?.selectedChange?.emit(newDate);
  }
}
